export const scrollToElementById = (elementSelector: string): void => {
    setTimeout(() => {
        const elementTOScroll = document.getElementById(elementSelector);
        if (elementTOScroll) {
            elementTOScroll.scrollIntoView({ behavior: 'smooth' });
        }
    }, 0);
};
